var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOrangeStarR = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 13,
  viewBox: "0 0 14 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.3384 1.03621C6.54664 0.395296 7.45336 0.395298 7.6616 1.03621L8.63993 4.04718C8.73306 4.33381 9.00016 4.52786 9.30153 4.52786H12.4675C13.1414 4.52786 13.4215 5.39021 12.8763 5.78631L10.3151 7.64719C10.0712 7.82434 9.96922 8.13833 10.0624 8.42496L11.0407 11.4359C11.2489 12.0768 10.5154 12.6098 9.97018 12.2137L7.40889 10.3528C7.16508 10.1757 6.83492 10.1757 6.59111 10.3528L4.02982 12.2137C3.48463 12.6098 2.75108 12.0768 2.95932 11.4359L3.93765 8.42496C4.03078 8.13833 3.92875 7.82434 3.68494 7.64719L1.12365 5.78631C0.578457 5.3902 0.85865 4.52786 1.53255 4.52786H4.69847C4.99984 4.52786 5.26694 4.3338 5.36007 4.04718L6.3384 1.03621Z",
  fill: "#FF8C00"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgOrangeStarR);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/orange-star-r.451101c8b16b0723267a92344e754206.svg";